/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Split, SplitInterface } from "../Split";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_thirdwebFee",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IERC20Upgradeable",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ERC20PaymentReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
    ],
    name: "PayeeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReceived",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "PaymentReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractType",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractVersion",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "token",
        type: "address",
      },
    ],
    name: "distribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "distribute",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_defaultAdmin",
        type: "address",
      },
      {
        internalType: "string",
        name: "_contractURI",
        type: "string",
      },
      {
        internalType: "address[]",
        name: "_trustedForwarders",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "_payees",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_shares",
        type: "uint256[]",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "payee",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "payeeCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "token",
        type: "address",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "released",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "shares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "thirdwebFee",
    outputs: [
      {
        internalType: "contract ITWFee",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "token",
        type: "address",
      },
    ],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalReleased",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalShares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type SplitConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SplitConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Split__factory extends ContractFactory {
  constructor(...args: SplitConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Split";
  }

  deploy(
    _thirdwebFee: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Split> {
    return super.deploy(_thirdwebFee, overrides || {}) as Promise<Split>;
  }
  getDeployTransaction(
    _thirdwebFee: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_thirdwebFee, overrides || {});
  }
  attach(address: string): Split {
    return super.attach(address) as Split;
  }
  connect(signer: Signer): Split__factory {
    return super.connect(signer) as Split__factory;
  }
  static readonly contractName: "Split";
  public readonly contractName: "Split";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SplitInterface {
    return new utils.Interface(_abi) as SplitInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Split {
    return new Contract(address, _abi, signerOrProvider) as Split;
  }
}
